export default __webpack_public_path__ + "static/media/Contact.49c4cf7d.png";